import { hasVendorGrant } from './gdpr_consent'

declare let _conv_q: Array<{ what: string }>

// https://support.convert.com/hc/en-us/articles/360037946851-delay-cookie-writing-and-data-collection-until-visitor-consent-is-provided
export function updateConvertConsent(): void {
  window._conv_q ??= []

  if (hasVendorGrant('Convert')) {
    _conv_q.push({ what: 'consentGiven' })
  } else {
    _conv_q.push({ what: 'consentRequired' })
  }
}
